import React from 'react';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { StyledTabItem } from './index.style';

const TabItem = ({ label, count, isActive, onClick, styleTab }) => {
  const { t } = useTranslation();
  return (
    <StyledTabItem
      className={isActive ? 'active' : ''}
      onClick={onClick}
      styleTab={styleTab}
    >
      <Typography variant="body-14-medium">
        {t(label)} {count && `(${count})`}
      </Typography>
    </StyledTabItem>
  );
};

export default TabItem;
